import { render, staticRenderFns } from "./AppLocations.vue?vue&type=template&id=2d2bf3f0"
import script from "./AppLocations.vue?vue&type=script&lang=js"
export * from "./AppLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports